import { Card, Form, Button, Input, Col, Checkbox, Divider, Statistic } from 'antd';
import { useParams } from 'react-router-dom';
import { useCompanyData } from '../../../../../../../Hooks/TT_ELD/Companies';
import { sendEvent } from '../../../../../../../Utils/analytics';
import { companies } from '../../../../../../../API/TT_ELD/Users/company';

type MyObjectType = {
  [key: string | number]: any;
};
type params = {
  readonly id: any;
};

const NotificationCompany = () => {
  const [form] = Form.useForm();
  const { id } = useParams<params>();
  const { data, isFetching, isLoading, refetch }: MyObjectType = useCompanyData(id);

  const onSubmit = async (values: any) => {
    values = {
      ...values,
      chatId: values.chatId ? values.chatId : null,
      config: {
        ...values.config,
        eldType: data?.config?.eldType || null,
      },
    };
    const body: MyObjectType = {};

    let key: string | number;
    let key2: string | number;
    for (key in values) {
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] != null) {
        for (key2 in values[key]) {
          if (
            typeof values[key][key2] === 'object' &&
            !Array.isArray(values[key][key2]) &&
            values[key][key2] != null
          ) {
            if (JSON.stringify(values[key][key2]) != JSON.stringify(data[key][key2])) {
              body[key] = values[key];
              break;
            }
          } else if (data[key][key2] != values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data[key] != values[key]) {
        body[key] = values[key];
      }
    }

    sendEvent(
      `Company page`,
      `Company  Tab Notification  `,
      `Company page Tab Notification Submit`,
      1,
    );
    companies.companyPatchData(body, id);
    refetch();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  type FieldType = {
    notificationChatId?: number;
    notificationEmail?: string;
    type?: string;
    chatId?: string;
  };

  return (
    <div className="mainPage">
      <Card loading={isLoading || isFetching} title="Notifications" style={{ width: '100%' }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
          name="basic"
          initialValues={{
            ...data,
          }}
        >
          <div style={{ display: 'flex' }}>
            <div style={{ width: '100%', marginRight: '10px' }}>
              <Col span={8}>
                <Form.Item<FieldType>
                  wrapperCol={{ span: '100%' }}
                  label="Notification Chat ID"
                  name="notificationChatId"
                >
                  <Input placeholder="Enter Chat ID" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item<FieldType>
                  wrapperCol={{ span: '100%' }}
                  label="Notification Email"
                  name="notificationEmail"
                >
                  <Input placeholder="Enter Email" />
                </Form.Item>
              </Col>
            </div>
            <div style={{ width: '100%', marginLeft: '10px', textAlign: 'end' }}>
              <Col span={8}>
                <Form.Item<FieldType>
                  wrapperCol={{ span: '100%' }}
                  label="Violations Chat ID"
                  name="chatId"
                >
                  <Input placeholder="Enter Chat ID" />
                </Form.Item>
              </Col>
            </div>
          </div>
          <>
            <Divider />
            <Form.Item
              label="Notification Type"
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.config !== currentValues.config
              }
            >
              {() => {
                return (
                  <>
                    <Form.Item
                      name={['config', 'notificationWeighStation']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox>Weigh Station</Checkbox>
                    </Form.Item>
                    <Form.Item
                      name={['config', 'notificationAlert']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox style={{ marginLeft: 24 }}>Collision Alert</Checkbox>
                    </Form.Item>
                    <Form.Item
                      name={['config', 'notificationEldDisconnect']}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox style={{ marginLeft: 24 }}>ELD Disconnect</Checkbox>
                    </Form.Item>
                  </>
                );
              }}
            </Form.Item>
          </>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default NotificationCompany;
